import React, {Component} from 'react';
import {BaseEventEditor, BaseEventViewer} from './base_event';
import {RelatedToOptions} from '../../../constants.js.erb';

class ComEmailEditor extends BaseEventEditor {
  formFields() {
    let {patient} = this.props;
    return formFields(patient);
  }

}


class ComEmailViewer extends BaseEventViewer {
  formFields() {
    let {patient} = this.props;
    return formFields(patient);
  }
}


export default {
  viewer: ComEmailViewer,
  editor: ComEmailEditor
}


function formFields(patient) {
  let contacts = patient.contacts.map(c => {return {id: c.id, text: c.name}});
  let medical_team_members = patient.medical_team_members.map(m => {return {id: m.id, text: m.person.name}});

  return [
    {name: 'date', type: 'date', required: true, inSummary: true, label: "Date Email was Received", hint: "You may select date or type in this field."},
    {name: 'date_estimated', label: 'This Date is Estimated', type: 'bool'},
    {name: 'related_to', type: 'select', collection: RelatedToOptions},
    {name: 'user', inSummary: true, label: 'Sent to', hint: 'To what email address was this email sent?'},
    {name: 'peer_type', type: 'select', label: 'Sent by', collection: ['patient', 'contact', 'medical_team', 'other'], labelTransform: 'titleize', inSummary: true},
    {name: 'contact_id', type: 'select2', collection: contacts, visible: e => e.peer_type === 'contact', idField: 'id', labelField: 'text', hint: 'To appear here, contacts must be added to the patient.'},
    {name: 'medical_team_member_id', type: 'select2', collection: medical_team_members, visible: e => e.peer_type === 'medical_team', idField: 'id', labelField: 'text', hint: 'To appear here, medical team members must be added to the patient.'},
    {name: 'description', type: 'text', label: 'Email Description', hint: 'Feel free to drop text of email into this field'}
  ];
}
